import { Button, Dialog, Icon, Portal } from "@chakra-ui/react";
import { useState } from "react";
import { FaTimes } from "react-icons/fa";
import PdfViewer from "../../../common/PdfViewer";

interface PdfDialogProps {
  title: string;
  pdfUrl: string;
  children: React.ReactNode;
}

const PdfDialog = ({ title, pdfUrl, children }: PdfDialogProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Trigger Button */}
      <div onClick={() => setOpen(true)}>{children}</div>

      {/* Dialog */}
      <Dialog.Root open={open} onOpenChange={(e) => setOpen(e.open)}>
        <Portal>
          <Dialog.Backdrop bg="blackAlpha.700" backdropFilter="blur(8px)" />
          <Dialog.Positioner>
            <Dialog.Content
              maxW="90vw"
              maxH="90vh"
              w="full"
              h="full"
              bg="white"
              shadow="2xl"
              borderRadius="lg"
              overflow="hidden"
            >
              <Dialog.CloseTrigger asChild>
                <Button
                  position="absolute"
                  top={4}
                  right={4}
                  size="sm"
                  variant="ghost"
                  zIndex={10}
                  onClick={() => setOpen(false)}
                >
                  <Icon as={FaTimes} />
                </Button>
              </Dialog.CloseTrigger>

              <Dialog.Header
                bg="gray.50"
                borderBottom="1px solid"
                borderColor="gray.200"
                p={4}
              >
                <Dialog.Title fontSize="lg" fontWeight="semibold">
                  {title}
                </Dialog.Title>
              </Dialog.Header>

              <Dialog.Body
                p={0}
                h="calc(100% - 80px)"
                bg="white"
                overflow="hidden"
              >
                {open && <PdfViewer url={pdfUrl} />}
              </Dialog.Body>
            </Dialog.Content>
          </Dialog.Positioner>
        </Portal>
      </Dialog.Root>
    </>
  );
};

export default PdfDialog;
